<button mat-stroked-button
        class="download-button text-hidden text-unhide-hover"
        (click)="onDownloadClick()"
        matTooltip="Download Bulk Locations Creation Template">
  <svg-icon class="side-nav-icon"
            src="assets/svg/cloud-download-icon.svg"></svg-icon>
  <span class="button-text">Bulk Template</span>
</button>
